import { Navigate } from 'react-router-dom';

interface Props {
  otherwise: string;
}

const NavigateFromReturnUrl = ({ otherwise }: Props) => {
  const to = otherwise;

  return <Navigate to={to} />;
};

export default NavigateFromReturnUrl;
